import { Navigate, useLocation } from 'react-router-dom'
import type { SettingsSectionId } from './settingsSections'

/**
 * L-NAV-4 — une ancienne adresse de réglages (`/settings/integrations`,
 * `/settings/allodons`) devient une SECTION de la console.
 *
 * La requête d'origine est CONSERVÉE (`?connectionId=` posé par un lien
 * « Configurer », un favori…) et la section s'y ajoute ; une `section`
 * éventuellement présente est écrasée par celle de la route. L'état de
 * navigation suit aussi : le motif d'une redirection vers « Intégrations »
 * (`integrationRequired`) y est conservé.
 */
export function SettingsSectionRedirect({ section }: { section: SettingsSectionId }) {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  params.delete('section')
  const search = new URLSearchParams({ section })
  params.forEach((value, key) => search.append(key, value))
  return (
    <Navigate
      replace
      to={{ pathname: '/settings', search: `?${search.toString()}`, hash: location.hash }}
      state={location.state}
    />
  )
}

export default SettingsSectionRedirect
